import React, { useState } from "react";

import { Input } from "components/Input";

export const ApiSearch = ({ onChange }) => {
  const [timeoutId, setTimeoutId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleOnChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (searchQuery === query) {
      return;
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      onChange(query);
    }, 1000);
    setTimeoutId(newTimeoutId);
  };
  return <Input placeholder="Search" onChange={handleOnChange} />;
};
